class FloatingContact {
  constructor() {
    this.init = this.init.bind(this);
    this.init();
  }

  init() {
    const floatingContactContainer = document.querySelector('[data-floating-contact]');
    const floatingContactTrigger = floatingContactContainer.querySelector('.floating-contact__trigger');
    let lastScrollTop = 0;

    if (floatingContactContainer && floatingContactTrigger) {
      floatingContactTrigger.addEventListener('click', (e) => {
        e.preventDefault();

        floatingContactContainer.classList.toggle('floating-contact--folded-out');
      });

      window.addEventListener('scroll', () => {
        if (window.scrollY > lastScrollTop) {
          floatingContactTrigger.classList.add('floating-contact__trigger--hide');
        } else {
          floatingContactTrigger.classList.remove('floating-contact__trigger--hide');
        }

        lastScrollTop = window.scrollY;
      });
    }
  }
}

export default new FloatingContact();
